/**
 *
 * key
 *
 */

 const key = 'bXlFcXVpcG1lbnRTY2hlZHVsZQ=='

 export default key
 